import { globalEndpoints } from './global';

export const orderEndpoints = {
  getOrderRoutes: (orderIdEncrypted) => `${globalEndpoints.apiUrl}/Order/${orderIdEncrypted}/Routes`,
  getDispensationInfo: (orderIdEncrypted) => `${globalEndpoints.apiUrl}/Order/DispensationInfo/${orderIdEncrypted}`,
  getDeliveryDevices: () => `${globalEndpoints.apiUrl}/Order/DeliveryDevices`,
  getDispensationAmount: (patientId:string) => `${globalEndpoints.apiUrl}/Order/DispensationAmount/${patientId}`,
  saveDispensation: () => `${globalEndpoints.apiUrl}/Order/Dispensation`,
  getCurrentOrderSummary: (patientIdEncrypted) => `${globalEndpoints.apiUrl}/Order/${patientIdEncrypted}/CurrentOrderSummary`,
  getOrderSummary: (certificationIdEncrypted) => `${globalEndpoints.apiUrl}/Order/${certificationIdEncrypted}/OrderSummary`,
  saveOrders: () => `${globalEndpoints.apiUrl}/Order/SaveOrders`,
};
